var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tt",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e00000",
    fillRule: "evenodd",
    d: "M463.7 480 0 1v478.8zM176.3 0 640 479V.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M27.7.2h118.6l468.2 479.3H492.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.faa91be4a726ae707d5d6d540c79e81b.svg";
export { ForwardRef as ReactComponent };